<div class="grid grid-cols-3 items-center px-4 py-1 bg-(--pg-surface) text-xs">
    <div>
        <img class="h-[24px]" src="assets/brand/momentum-health-logo.svg" alt="Momentum Health"/>
    </div>
    <div class="flex items-center justify-center gap-3 whitespace-nowrap overflow-hidden">
        <span class="hidden sm:inline truncate">Copyright &copy; {{ currentYear }} Momentum - All Rights Reserved</span>
        <span class="flex items-center gap-2 text-(--pg-brand-blue) shrink-0">
            <button type="button" class="hover:underline hover:cursor-pointer" (click)="openWebAppReleaseNotes()">WA v{{ webAppVersion() }}</button>
            <span aria-hidden="true">&middot;</span>
            <button type="button" class="hover:underline hover:cursor-pointer" (click)="openApiReleaseNotes()">API v{{ apiVersion() }}</button>
        </span>
    </div>
    <div class="justify-self-end">
        <img class="h-[24px]" src="assets/brand/perigon-connected-colour.svg" alt="Perigon Connected"/>
    </div>
</div>